import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
const MAX = Infinity;
const MIN = 0;
let default_1 = class default_1 extends Vue {
    rangeLeft;
    rangeRight;
    minValueChange(val) {
        this.$emit('update:rangeLeft', val);
    }
    maxValueChange(val) {
        this.$emit('update:rangeRight', val);
    }
    ruleForm = {
        minValue: this.$props.rangeLeft,
        maxValue: this.$props.rangeRight,
    };
    get rules() {
        const numRex = /^\d+$/;
        return {
            minValue: [
                { required: true, message: `${this.$t('inputRule')}`, trigger: 'blur' },
                {
                    validator: (rule, value, callback) => {
                        const val = Number(value);
                        if (val < MIN || val > MAX || !numRex.test(value) || val >= this.ruleForm.maxValue) {
                            callback(new Error(`${this.$t('inputRuleTips')}`));
                        }
                        else {
                            callback();
                        }
                    },
                    trigger: 'blur',
                },
            ],
            maxValue: [
                { required: true, message: `${this.$t('inputRule')}`, trigger: 'blur' },
                {
                    validator: (rule, value, callback) => {
                        const val = Number(value);
                        if (val < MIN || val > MAX || !numRex.test(value) || val <= this.ruleForm.minValue) {
                            callback(new Error(`${this.$t('inputRuleTips')}`));
                        }
                        else {
                            callback();
                        }
                    },
                    trigger: 'blur',
                },
            ],
        };
    }
    isValidate() {
        let isValidate = null;
        this.$refs.ruleForm.validate((valid) => {
            if (valid) {
                isValidate = true;
            }
            else {
                isValidate = false;
            }
        });
        return isValidate;
    }
};
__decorate([
    Prop({ default: '40000', type: String })
], default_1.prototype, "rangeLeft", void 0);
__decorate([
    Prop({ default: '700000', type: String })
], default_1.prototype, "rangeRight", void 0);
__decorate([
    Watch('ruleForm.minValue')
], default_1.prototype, "minValueChange", null);
__decorate([
    Watch('ruleForm.maxValue')
], default_1.prototype, "maxValueChange", null);
default_1 = __decorate([
    Component({
        name: 'TargetSize',
        i18n: {
            messages: {
                zh: {
                    min: '最小值',
                    max: '最大值',
                    ideal: '推荐值',
                    inputRule: '请输入阈值',
                    inputRuleTips: '请输入正确的阈值',
                },
                en: {
                    min: 'min',
                    max: 'max',
                    ideal: 'Ideal',
                    inputRule: 'Please enter ideal value',
                    inputRuleTips: 'Please enter correct value',
                },
            },
        },
    })
], default_1);
export default default_1;
